import ShipperDetail from "@/classes/bookings/ShipperDetail";
import {ref, inject, computed, toRefs, reactive, onMounted, onUnmounted} from 'vue';

// const validationViewModel = inject("validationViewModel");

export default class AddressEntry {

    constructor(model, validation) {

        this.props = model;
        this.validationViewModel = validation;
    }

    closeShipperModel() {

    validationViewModel[props.validationViewModelSection].shipperName.value = false;
    props.modelValue.newShipperCompany = new ShipperDetail();

}



}